export default __webpack_public_path__ + "static/media/AES_B.a79aa582.svg";